<template lang='pug'>
  .reward
    .reward-card(@click='openModal()' :href='`#reward${reward.id}`' data-toggle='modal')
      .icon-container
        img.icon(:src='reward.icon')
        .fully-redeemed-image.default(v-if='isFullyRedeemed')
        .btn.btn-white.quick-view(v-text='$t("account.rewardsBoutique.quickView")')
      .details
        template(v-if='reward.tierExclusiveLabels.length === 0')
          .tier-label(v-text='')
        template(v-else)
          span.tier-label(
            v-for='label in reward.tierExclusiveLabels'
            v-text='label.text + " "'
            :style='{ color: label.hexCode }'
          )
        .brand-name(v-text='reward.brandName')
        .product-name(v-text='reward.productName')
        .show-points
          template(v-if="discountable")
            .original-points(v-text='`${reward.originalPoints} ${$t("common.points")}`')
            span.points(v-text='`${reward.points} ${$t("common.points")}`')
            span.discount-label(v-text='`(${reward.discountLabel})`')
          template(v-else)
            .points(v-text='`${reward.points} ${$t("common.points")}`')
    AddRewardToBagButton(
      v-if='!isGuestUser'
      :rewardId='reward.id'
      :isRedeemable='isRewardRedeemable'
      :isRewardAddedToBag='isRewardAddedToBag'
      :classes='buttonClasses'
    )

    .modal.fade(:id='`reward${reward.id}`' aria-hidden='true' role='dialog' tabindex='-1' v-if='showModal')
      .modal-dialog.reward-modal-dialog(role='document')
        .modal-content
          .modal-body
            button.close.modal-close(type='button' data-dismiss='modal' aria-label='Close' @click='closeModal()')
            RewardModal(
              :reward='reward'
              :is-redeemable='isRewardRedeemable'
              :is-guest-user='isGuestUser'
              :is-reward-added-to-bag='isRewardAddedToBag'
            )
</template>

<script>
import RewardModal from './reward-modal.vue'
import AddRewardToBagButton from './add-reward-to-bag-button.vue'

export default {
  components: {
    RewardModal,
    AddRewardToBagButton
  },

  props: {
    reward: {
      type: Object,
      required: true
    },
    isGuestUser: Boolean,
    isRewardAddedToBag: Boolean
  },

  data () {
    return {
      showModal: false,
      isRewardRedeemable: this.reward.isRedeemable,
      buttonClasses: ['btn-block', 'btn-sm'],
      isFullyRedeemed: this.reward.isFullyRedeemed
    }
  },

  computed: {
    discountable () {
      return this.reward.originalPoints && this.reward.points !== this.reward.originalPoints
    }
  },

  watch: {
    isRewardAddedToBag () {
      this.isRewardRedeemable = !this.isRewardAddedToBag
      this.closeModal()
    },

    reward () {
      this.isRewardRedeemable = this.reward.isRedeemable
      this.isFullyRedeemed = this.reward.isFullyRedeemed
    }
  },

  methods: {
    openModal () {
      this.showModal = true
    },

    closeModal () {
      this.showModal = false
    }
  }
}
</script>

<style lang='scss' scoped>
  .modal-dialog.reward-modal-dialog {
    max-width: 710px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .reward {
    margin-top: 30px;
    padding: 10px;
    width: 50%;
    display: flex;
    flex-direction: column;

    @include media-breakpoint-up(sm) {
      width: 33%;
    }

    @include media-breakpoint-up(lg) {
      width: 25%;
    }

    &:hover {
      .quick-view {
        display: block;
        position: absolute;
        bottom: 6px;
        left: 0;
        width: 100%;
        opacity: 0.8;
      }
    }

    > .reward-card {
      display: flex;
      flex-direction: column;
      max-width: 164px;
      margin: 0 auto;
      flex-grow: 1;
    }

    > .add-reward-to-bag-button {
      width: 164px;
      margin: 0 auto;
    }

    .fully-redeemed-image {
      background-position: 50% 40%;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;
    }

    .default {
      background-image: url('../../assets/images/cart/fully-redeemed.svg');
    }

  }

  .icon-container {
    position: relative;
    width: 164px;
    height: 164px;

    > .icon {
      width: 100%;
      max-height: 100%;
    }

    > .quick-view {
      display: none;
    }
  }

  .details {
    flex-grow: 1;

    > .tier-label {
      font-size: 10px;
      text-transform: uppercase;
      line-height: normal;
      height: 16px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      margin-top: 5px;
    }

    > .product-name {
      word-break: break-word;
    }

    > .brand-name {
      @include font-weight-bold;
      text-transform: uppercase;
    }

    > .show-points {
      > .points, div > div > span.points {
        @include font-weight-bold;
        text-transform: capitalize;
        padding-right: 5px;
      }

      > .original-points {
        text-transform: capitalize;
        text-decoration: line-through;
      }

      > span.discount-label {
        @include font-weight-bold;
        text-transform: capitalize;
        color: $brand-primary;
      }
    }
  }

  .modal-body {
    padding: 30px;
  }
</style>
